module.exports = __webpack_public_path__ + "cfc16bdc4b94f18d10f8d73e1f3c43f2.MP3";